
























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'

    import userList from '@/store/entities/userinfo'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    class Packed {
        returnNumber: string;
    }
    @Component
    export default class EditLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        selectuser: userList = new userList();
        user: Array<userList> = [];
        automaticJump: boolean;
        PackedModel: Packed = new Packed();

        created() {

        }
        ruleInline = {
            returnNumber: [
                { required: true, message: '退件编号不能为空', trigger: 'blur' }
            ],
        };


        async check() {
            var returnNumber = this.PackedModel.returnNumber;
            if (!returnNumber) {
                this.$Message.error('检查的快递单号不能为空。');
                return;
            }
            var id = this.$store.state.fontoverseasreturnorders.id;
            var orderNumber = this.$store.state.fontoverseasreturnorders.orderNumber;
            await this.$store.dispatch({
                type: 'fontoverseasreturnorders/addRerurnOrder',
                data: { orderId: id, returnNumber: this.PackedModel.returnNumber, orderNumber: orderNumber }
            });
           
            //var timestamp1 = (new Date()).valueOf().toString();
            //if (this.automaticJump) {
            //    //this.$Modal.success({ title: "打包成功", content: "即将跳转到【快递单号入库页面】！" });
            //    this.$router.push({ name: 'intoLogistics', params: { JumpPage: timestamp1 } });
            //}
            (this.$refs.packForm as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);
        }


        cancel() {
            (this.$refs.packForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
    }
